/* cf-calc-phone-fixes.js - Click Fencing calculators on a PHONE: the screen stops getting in the way.
 *
 * Pete 2026-10-08: "make the calculator easy to use ... on a mobile", then "build it all" on the deep
 * dive report (C:\cfwork\mobile-1008, vault: click-fencing-mobile 8 Oct). Each fix below was measured
 * on the live site at 375x812 (iPhone) and 360x780 (Samsung) before it was written:
 *
 *  1. ONE Next. On step 1 the floating "Next ->" pill (cf-sticky-next.js) sat on top of the bottom
 *     bar's price, beside the bar's own Next. While that bar is showing, the pill stays away.
 *  2. "Got a question?" (#cfq) covered 46% of whatever control scrolled under it. On the calculators it
 *     becomes the round icon button (same button, same panel, its words stay as its label for screen
 *     readers) and steps aside while a field is being typed in.
 *  3. Arriving on Configure Sections the length box was below the fold under an empty preview. The
 *     page now lands with the section buttons at the top and the length box on screen.
 *  4. The "How many sections" list opened with options 6-10 under the bottom bar; it now scrolls up to
 *     fit when opened.
 *  5. The section buttons (tabs, Next, + Add section, Delete) stacked one per row, 180-320px. Now the
 *     tabs on one row (sideways scroll when there are many), then Add/Delete and Next (Next on its own
 *     line only when there is no room).
 *  7. The second gate "Measured from an end" row: From box and distance box share the width.
 *  9. Review & Checkout folds: price groups open with a tap, Configuration Summary folds, parts rows
 *     put the name on its own line (see the section below).
 *  6. Optional add-on rows (glass grout, anchors) ran off the screen ($88.79 showed as "$88"). The name
 *     now takes its own line, with quantity and price on the next.
 * Phones only (<=749px). Display and navigation only - no price, product, quantity or cart line.
 * Roll back: remove its line from snippets/cf-mobile-extra.liquid.
 */
(function () {
  'use strict';
  if (window.__cfCalcPhoneFixes) return;
  window.__cfCalcPhoneFixes = true;

  var CALC = /^\/pages\/(glass-fencing|fence-calculator|blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence)\/?$/;
  if (!CALC.test(location.pathname)) return;
  var MQ = window.matchMedia('(max-width: 749px)');

  try {
    var s = document.createElement('style');
    s.id = 'cf-calc-phone-fixes-css';
    s.textContent = [
      '@media (max-width:749px){',
      /* 1 */
      'body.cf-cmc-on #cf-sticky-next{display:none!important}',
      /* 2 */
      'body #cfq #cfq-open .cfq-label{display:none!important}',
      'body #cfq #cfq-open{width:48px!important;height:48px!important;padding:0!important;border-radius:50%!important;justify-content:center!important;gap:0!important}',
      'body #cfq #cfq-open svg{width:22px!important;height:22px!important}',
      'body.cf-cmk-typing #cfq{opacity:0!important;pointer-events:none!important;transform:translateY(140%)!important;transition:opacity .15s,transform .15s!important}',
      /* 5 */
      'body .calculator-page #section-tabs-container[class] > div{display:flex!important;flex-wrap:wrap!important;gap:8px!important;align-items:center!important;margin-bottom:12px!important;overflow:visible!important;padding:0!important}',
      'body .calculator-page #section-tabs-container[class] > div > div:first-child{flex:0 0 100%!important;order:1!important;display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;gap:6px!important;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding-bottom:2px!important;margin:0!important}',
      'body .calculator-page #section-tabs-container[class] > div > div:first-child::-webkit-scrollbar{display:none}',
      'body .calculator-page #section-tabs-container[class] > div > div:last-child:not(:first-child){order:2!important;margin:0!important;display:flex!important;gap:6px!important;flex-wrap:nowrap!important}',
      /* Next goes last and right; if Add/Delete leave no room it takes its own line, full width */
      'body .calculator-page #section-tabs-container[class] > div > button.btn-primary{order:3!important;margin:0 0 0 auto!important;position:static!important;white-space:nowrap!important;flex:1 0 auto!important;max-width:100%!important}',
      'body .calculator-page #section-tabs-container[class] button{height:40px!important;min-height:40px!important;padding:0 12px!important;font-size:14px!important;line-height:1!important;border-radius:8px!important;white-space:nowrap!important;flex:0 0 auto!important;width:auto!important}',
      /* 7: the second-gate 'Measured from an end' row - the From select was forced to full width and crushed the distance box to 18px (Pete 9 Oct, Blade, his Samsung) */
      'body .calculator-page div[id$="-measure"][style] > select[id]{flex:0 0 52%!important;width:52%!important;min-width:0!important;max-width:52%!important;padding-left:8px!important;padding-right:22px!important;font-size:14px!important}',
      'body .calculator-page div[id$="-measure"][style] > input[id]{flex:1 1 auto!important;width:auto!important;min-width:0!important;max-width:none!important;font-size:16px!important}',
      /* 8: Flat Top's on/off rows (Gate Required?, Raked Panel Required?, Second gate) - a page style made the label a plain block, so the switch sat jammed against the words */
      'body .calculator-page .form-group label.toggle-label[style]{display:flex!important;justify-content:space-between!important;align-items:center!important;width:100%!important;gap:10px!important}',
      /* 10: slimmer top on the calculator pages (Pete 9 Oct). Same words and buttons, less height:
         the first control sat 49% of the way down a Samsung screen. */
      'body .announcement-bar{padding-top:3px!important;padding-bottom:3px!important}',
      'body .announcement-bar, body .announcement-bar *{font-size:11.5px!important;line-height:1.3!important}',
      'body .cf-mbar{padding-bottom:6px!important;gap:6px!important}',
      'body .cf-mbar a.cf-mbar__call, body .cf-mbar a.cf-mbar__draw{min-height:42px!important;padding:2px 8px!important;gap:6px!important}',
      'body .cf-mbar strong{font-size:13.5px!important}',
      'body .cf-mbar small{font-size:11px!important}',
      'body .calculator-page .calculator-header[class]{padding-top:4px!important;padding-bottom:2px!important;margin-bottom:4px!important}',
      'html body .calculator-page .calculator-header > h1, html body .calculator-page .calculator-header h1[style], html body .calculator-page .calculator-header h1{font-size:22px!important;line-height:1.15!important;margin:0!important;padding:0!important}',
      'body .calculator-page .calculator-tabs[class]{margin-bottom:8px!important;padding-top:2px!important;padding-bottom:2px!important}',
      'body .calculator-page .calculator-content[class]{padding:6px 4px!important}',
      'body .calculator-page .calculator-content[class] .calculator-column[class]{padding-top:12px!important}',
      'body .calculator-page #add-sections .calculator-column > h3:first-child{margin-top:0!important;margin-bottom:8px!important}',
      /* 11: the (i) after "How many sections in your pool fencing plan?" wrapped onto a line of its own on glass (Pete 10 Oct: "fix both") - the question and its (i) sit side by side */
      'body .calculator-page label[for="sections-count"]{display:flex!important;align-items:flex-start!important;gap:6px!important}',
      'body .calculator-page label[for="sections-count"] > .tooltip-container{flex:0 0 auto!important;margin-top:2px!important}',
      /* 6 */
      'body .calculator-page .addon-item[style] > div:first-child{flex-wrap:wrap!important;row-gap:8px!important}',
      'body .calculator-page .addon-item[style] > div:first-child > span:not(.addon-price){flex:1 1 calc(100% - 32px)!important;min-width:0!important;font-size:15px!important;line-height:1.3!important}',
      'body .calculator-page .addon-item[style] > div:first-child > div{margin-left:24px!important;display:flex!important;align-items:center!important;gap:8px!important}',
      'body .calculator-page .addon-item[style] > div:first-child > div > label[style]{position:static!important;margin:0!important;white-space:nowrap!important;font-size:15px!important;width:auto!important;flex:0 0 auto!important;display:inline-block!important}',
      'html body .calculator-page .addon-item[style] > div:first-child > div > input.addon-qty[type][style]{margin:0!important;flex:0 0 72px!important;width:72px!important;min-width:0!important;max-width:72px!important}',
      'body .calculator-page .addon-item[style] > div:first-child > .addon-price{margin-left:auto!important;font-size:16px!important}',
      '}'
    ].join('\n');
    (function attach() { var h = document.head || document.documentElement; if (h) h.appendChild(s); else setTimeout(attach, 10); })();
  } catch (e) {}

  function vis(el) { return !!(el && el.getClientRects().length && el.offsetParent !== null); }

  /* 2: the icon-only button keeps its name for screen readers */
  function labelQuestion() {
    var b = document.getElementById('cfq-open');
    if (b && !b.getAttribute('aria-label')) {
      var t = b.querySelector('.cfq-label strong');
      b.setAttribute('aria-label', t ? t.textContent.trim() : 'Got a question?');
    }
  }

  /* 3: land on the length box after Next on step 1 */
  var userScrolled = false;
  window.addEventListener('touchmove', function () { userScrolled = true; }, { passive: true });
  window.addEventListener('wheel', function () { userScrolled = true; }, { passive: true });
  function landOnConfigure() {
    userScrolled = false;
    var tries = 0;
    (function wait() {
      var f = document.getElementById('section-1-length');
      var tabs = document.getElementById('section-tabs-container');
      if (vis(f) && vis(tabs)) {
        // the calculator scrolls to the top itself just after switching step, so go after it
        var go = function () {
          if (userScrolled) return;
          var y = tabs.getBoundingClientRect().top + window.scrollY - 8;
          if (Math.abs(window.scrollY - y) > 20) window.scrollTo(0, Math.max(0, y));
        };
        setTimeout(go, 300); setTimeout(go, 900);
        return;
      }
      if (++tries < 40) setTimeout(wait, 50);
    })();
  }

  /* 4: keep an opened "How many sections" list clear of the bottom bar */
  function fitOpenList() {
    var sc = document.getElementById('sections-count');
    var g = sc && sc.closest('.form-group');
    if (!g) return;
    var opts = [].slice.call(g.querySelectorAll('*')).filter(function (x) {
      return x.children.length === 0 && /^\d{1,2}$/.test(x.textContent.trim()) && x.getClientRects().length;
    });
    if (opts.length < 3) return;
    var list = opts[0].parentElement, r = list.getBoundingClientRect();
    var bar = document.getElementById('cf-cmc-bar');
    var barH = bar && bar.classList.contains('cf-cmc-in') ? bar.offsetHeight : 0;
    var room = window.innerHeight - barH - 8;
    if (r.bottom > room) window.scrollBy(0, Math.min(r.bottom - room, Math.max(0, r.top - 8)));
  }

  document.addEventListener('click', function (e) {
    if (!MQ.matches) return;
    var t = e.target;
    if (!t || !t.closest) return;
    try {
      var step1 = document.getElementById('add-sections');
      var onStep1 = !step1 || step1.classList.contains('active');
      if (onStep1 && (t.closest('#sections-next-btn') || t.closest('#cf-cmc-bar button') || t.closest('#nav-next'))) landOnConfigure();
      var sc = document.getElementById('sections-count');
      var g = sc && sc.closest('.form-group');
      if (g && g.contains(t)) setTimeout(fitOpenList, 80);
    } catch (err) {}
  }, true);


  /* 9: REVIEW & CHECKOUT FOLD (Pete 9 Oct: "do the header, review fold and script trim next").
     On a phone the Review step ran 6-8 screens. Each price group (Section 1, Gate, Hardware ...) now
     shows its header and subtotal, and its parts open with a tap; the overall Total stays in view.
     Configuration Summary (which repeats the drawing and the price list) folds under its own heading.
     No new words - the existing headings are the buttons, with a chevron. Re-applied after every
     re-render, and a group the customer opened stays open. */
  var foldOpen = {};
  function foldKey(h) { return (h.textContent || '').replace(/\s+/g, ' ').replace(/\$[\d,.]+/g, '').trim(); }
  function makeFold(box, header, startOpen, cls) {
    if (!box || !header) return;
    cls = cls || 'cfr-open';
    var k = foldKey(header);
    if (!box.hasAttribute('data-cfr')) {
      box.setAttribute('data-cfr', '1');
      header.classList.add('cfr-h');
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      var toggle = function (e) {
        if (e && e.target && e.target.closest && e.target.closest('a,input,select,button:not(.cfr-h)')) return;
        var open = box.classList.toggle(cls);
        foldOpen[k] = open;
        header.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    }
    var open = Object.prototype.hasOwnProperty.call(foldOpen, k) ? foldOpen[k] : !!startOpen;
    box.classList.toggle(cls, open);
    if (cls !== 'cfr-open') box.classList.toggle('cfr-open', open);
    header.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function applyFolds() {
    if (!MQ.matches) return;
    var rv = document.getElementById('review-checkout');
    if (!rv || !rv.classList.contains('active')) return;
    [].slice.call(rv.querySelectorAll('.breakdown-section, .breakdown-category')).forEach(function (sec) {
      if (sec.children.length < 2) return;
      makeFold(sec, sec.firstElementChild, false);
    });
    var qs = document.getElementById('quote-summary');
    var h3 = qs && qs.parentElement && qs.parentElement.querySelector(':scope > h3');
    if (qs && h3) {
      var wrap = qs.parentElement;
      wrap.classList.add('cfr-summary');
      makeFold(wrap, h3, false, 'cfr-sum-open');
    }
  }
  try {
    var fs2 = document.createElement('style');
    fs2.textContent = [
      '@media (max-width:749px){',
      '.cfr-h{cursor:pointer;position:relative;padding-right:26px!important;-webkit-tap-highlight-color:transparent}',
      '.cfr-h::after{content:"";position:absolute;right:6px;top:50%;width:8px;height:8px;border-right:2px solid #64748b;border-bottom:2px solid #64748b;transform:translateY(-70%) rotate(45deg);transition:transform .15s}',
      '[data-cfr].cfr-open > .cfr-h::after{transform:translateY(-30%) rotate(-135deg)}',
      '[data-cfr]:not(.cfr-summary):not(.cfr-open) > :not(.cfr-h){display:none!important}',
      /* the summary heading shares its column with pricing type, delivery and the buttons: only the summary list folds */
      '[data-cfr].cfr-summary:not(.cfr-open) > #quote-summary{display:none!important}',
      '[data-cfr]:not(.cfr-summary):not(.cfr-open) > .cfr-h{margin-bottom:0!important;border-bottom:0!important}',
      /* parts rows: name on its own line, price line underneath */
      'body .calculator-page .breakdown-item[style]{flex-wrap:wrap!important;row-gap:2px!important;padding:6px 0!important;border-bottom:1px solid #eef2f6}',
      'body .calculator-page .breakdown-item[style] > .item-details[style]{flex:1 1 100%!important;min-width:0!important}',
      'body .calculator-page .breakdown-item[style] > .item-pricing[style]{flex:1 1 100%!important;display:flex!important;justify-content:space-between!important;align-items:baseline!important;text-align:left!important}',
      '}'
    ].join('\n');
    (function attach() { var h = document.head || document.documentElement; if (h) h.appendChild(fs2); else setTimeout(attach, 10); })();
  } catch (e) {}
  var foldT = null;
  function foldSoon() { clearTimeout(foldT); foldT = setTimeout(function () { try { applyFolds(); } catch (e) {} }, 60); }
  (function watchFold() {
    var root = document.body;
    if (!root) { setTimeout(watchFold, 50); return; }
    try {
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          var t = recs[i].target;
          if (t && t.closest && t.closest('#review-checkout')) { foldSoon(); return; }
          if (t && t.id === 'review-checkout') { foldSoon(); return; }
        }
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  })();

  function start() { labelQuestion(); setTimeout(labelQuestion, 2000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  try { console.log('[cf-calc-phone-fixes] installed'); } catch (e) {}
})();
